import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RootState} from "../../store/store";

type RecentlyDuplicatedSampleState = {
    sampleWasRecentlyDuplicated: boolean;
    showDuplicateSuccessToast: boolean;
};

const initialState: RecentlyDuplicatedSampleState = {
    sampleWasRecentlyDuplicated: false,
    showDuplicateSuccessToast: false,
};

const recentlyDuplicatedSampleSlice = createSlice({
    name: "recentlyDuplicatedSample",
    initialState,
    reducers: {
        setSampleWasRecentlyDuplicated: (state, action: PayloadAction<boolean>) => {
            state.sampleWasRecentlyDuplicated = action.payload;
        },
        setShowDuplicateSuccessToast: (state, action: PayloadAction<boolean>) => {
            state.showDuplicateSuccessToast = action.payload;
        },
    },
});

export const {setSampleWasRecentlyDuplicated, setShowDuplicateSuccessToast} = recentlyDuplicatedSampleSlice.actions;

export const selectSampleWasRecentlyDuplicated = (state: RootState) =>
    state.client.recentlyDuplicatedSample?.sampleWasRecentlyDuplicated ?? false;

export const selectShowDuplicateSuccessToast = (state: RootState) =>
    state.client.recentlyDuplicatedSample?.showDuplicateSuccessToast ?? false;

export default recentlyDuplicatedSampleSlice.reducer;
